import { useQuery, UseQueryResult } from 'react-query';

import { useAuth } from 'src/hooks';
import { getAccountAlert } from 'src/utils/urls';

import { AlertRevisonListType } from '../types/accountAlerts';
export async function fetchAccountAlert({
  token,
  tokenType,
  accountId,
  alertId,
}: TVariables): Promise<TResult[] | null | []> {
  const response = await fetch(getAccountAlert(accountId, alertId), {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}
export type TVariables = {
  token: string;
  tokenType: string;
  accountId: number;
  alertId: number;
};

export type TError = { message: string };

export type TResult = AlertRevisonListType;
function useGetAccountAlert(
  accountId: number | undefined | null,
  alertId: number | undefined,
  //   isEnable: boolean,
): UseQueryResult<TResult[], TError> {
  const { token, tokenType } = useAuth();
  return useQuery(
    ['get_account_alert', accountId, alertId],
    async () => {
      if (accountId && alertId) {
        const result = await fetchAccountAlert({
          token,
          tokenType,
          accountId,
          alertId,
        });
        return result;
      }
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      //   enabled: isEnable,
    },
  );
}

export { useGetAccountAlert };
